(function($){

	$('.history-banner__toggle, .history-banner__announce').on( 'click', function( event ) {
		event.preventDefault();
		$(this).closest('.history-banner').addClass('on');
	} );

	$('.history-banner__hide, .history-banner__close').on( 'click', function( event ) {
		event.preventDefault();
		$(this).closest('.history-banner').addClass('off');
	} );

})(jQuery);